var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEur(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1928_123554)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1928_123554)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -7.16699,
    width: 43.11,
    height: 28.6816,
    rx: 5.38875,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.943 4.57764e-05H-7.16699V28.6817H35.943V4.57764e-05Z",
    fill: "#003399"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3857 3.18671L13.8923 4.70214L14.6516 4.94834L14.3857 3.18671Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3857 3.18671L14.8791 4.70214L14.1199 4.94834L14.3857 3.18671Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9033 4.28839L14.307 4.28762L14.3074 5.08356L15.9033 4.28839Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9053 4.28801L14.613 5.22484L14.1429 4.57924L15.9053 4.28801Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3232 6.06941L14.8295 4.55376L14.0706 4.79974L15.3232 6.06941Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3232 6.0692L14.0313 5.13237L14.5003 4.48805L15.3232 6.0692Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8701 4.28841L14.4664 4.28764L14.466 5.08358L12.8701 4.28841Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8682 4.28801L14.1604 5.22484L14.6305 4.57924L12.8682 4.28801Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4492 6.0694L13.9429 4.55375L14.7019 4.79973L13.4492 6.0694Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4492 6.06918L14.7412 5.13235L14.2721 4.48804L13.4492 6.06918Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3857 22.308L13.8923 23.8234L14.6516 24.0696L14.3857 22.308Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3857 22.308L14.8791 23.8234L14.1199 24.0696L14.3857 22.308Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9033 23.4098L14.307 23.4091L14.3074 24.205L15.9033 23.4098Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9053 23.4094L14.613 24.3463L14.1429 23.7007L15.9053 23.4094Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3232 25.1908L14.8295 23.6752L14.0706 23.9212L15.3232 25.1908Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3232 25.1906L14.0313 24.2538L14.5003 23.6095L15.3232 25.1906Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8701 23.4098L14.4664 23.4091L14.466 24.205L12.8701 23.4098Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8682 23.4094L14.1604 24.3463L14.6305 23.7007L12.8682 23.4094Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4492 25.1909L13.9429 23.6752L14.7019 23.9212L13.4492 25.1909Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4492 25.1906L14.7412 24.2538L14.2721 23.6095L13.4492 25.1906Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.80859 12.7476L4.3152 14.263L5.07446 14.5092L4.80859 12.7476Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.80859 12.7476L5.30199 14.263L4.54273 14.5092L4.80859 12.7476Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.32617 13.8494L4.72989 13.8486L4.73028 14.6445L6.32617 13.8494Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.32812 13.849L5.03588 14.7858L4.56579 14.1402L6.32812 13.849Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.74609 15.6305L5.25239 14.1148L4.49344 14.3608L5.74609 15.6305Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.74609 15.6302L4.45415 14.6934L4.92318 14.0491L5.74609 15.6302Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.29102 13.8494L4.8873 13.8487L4.88691 14.6446L3.29102 13.8494Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.29004 13.849L4.58229 14.7859L5.05237 14.1403L3.29004 13.849Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.87207 15.6305L4.36577 14.1148L5.12473 14.3608L3.87207 15.6305Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.87207 15.6302L5.16402 14.6934L4.69498 14.0491L3.87207 15.6302Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.65918 7.3502L9.95114 6.41336L9.48212 5.76906L8.65918 7.3502Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.65918 7.35043L9.1529 5.83477L9.91184 6.08074L8.65918 7.35043Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.0791 5.56956L9.37064 6.50595L9.84008 5.86118L8.0791 5.56956Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.08105 5.56978L9.67751 5.56936L9.6773 6.36566L8.08105 5.56978Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.59863 4.46788L9.10492 5.98354L9.86386 6.22951L9.59863 4.46788Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.59863 4.46788L10.0917 5.98309L9.33213 6.22951L9.59863 4.46788Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5361 7.35034L9.24461 6.41398L9.71406 5.7692L10.5361 7.35034Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5361 7.35014L10.043 5.83491L9.28348 6.08131L10.5361 7.35014Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1172 5.56862L9.8253 6.50538L9.35621 5.861L11.1172 5.56862Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1172 5.56879L9.52069 5.56912L9.52052 6.3655L11.1172 5.56879Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.0293 10.8498L6.53558 9.33415L5.77664 9.58012L7.0293 10.8498Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.0293 10.8496L5.73734 9.91274L6.20636 9.26843L7.0293 10.8496Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.1543 10.8497L6.44582 9.91329L5.97637 9.26851L5.1543 10.8497Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.1543 10.8495L5.64741 9.33422L6.40695 9.58063L5.1543 10.8495Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.57324 9.06796L5.86513 10.0047L6.33422 9.36034L4.57324 9.06796Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.57324 9.06813L6.16974 9.06847L6.16991 9.86484L4.57324 9.06813Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.61133 9.06871L6.31979 10.0051L5.85035 9.36033L7.61133 9.06871Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.60938 9.06892L6.01292 9.06851L6.01313 9.8648L7.60938 9.06892Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.0918 7.96722L6.58551 9.48289L5.82657 9.72886L6.0918 7.96722Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.0918 7.96722L5.59872 9.48243L6.3583 9.72886L6.0918 7.96722Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.60938 18.6301L6.01325 18.629L6.0138 19.4246L7.60938 18.6301Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.61035 18.6295L6.31826 19.5662L5.8481 18.9205L7.61035 18.6295Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.03027 20.4112L6.53577 18.8953L5.77728 19.1408L7.03027 20.4112Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.03223 20.4104L5.73991 19.4732L6.20858 18.8293L7.03223 20.4104Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.15332 20.4102L6.44469 19.474L5.97508 18.8291L5.15332 20.4102Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.15332 20.4095L5.646 18.8943L6.40573 19.141L5.15332 20.4095Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.08887 17.5277L6.58296 19.0436L5.82439 19.2893L6.08887 17.5277Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.08887 17.5277L5.59617 19.0426L6.35612 19.2893L6.08887 17.5277Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.57227 18.6289L6.16872 18.6293L6.16893 19.4256L4.57227 18.6289Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.57227 18.6287L5.86419 19.5655L6.33325 18.9211L4.57227 18.6287Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1152 22.1293L9.51911 22.1282L9.51966 22.9238L11.1152 22.1293Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1162 22.1287L9.82412 23.0654L9.35395 22.4197L11.1162 22.1287Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5371 23.9106L10.0426 22.3946L9.28412 22.6401L10.5371 23.9106Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5391 23.9097L9.24675 22.9725L9.71542 22.3286L10.5391 23.9097Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.66016 23.9095L9.95153 22.9733L9.48192 22.3284L8.66016 23.9095Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.66016 23.9088L9.15283 22.3936L9.91256 22.6403L8.66016 23.9088Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.59473 21.027L10.0888 22.5429L9.33025 22.7886L9.59473 21.027Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.59473 21.027L9.10202 22.542L9.86198 22.7886L9.59473 21.027Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.07812 22.128L9.67458 22.1284L9.67479 22.9247L8.07812 22.128Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.07812 22.1278L9.37005 23.0646L9.8391 22.4203L8.07812 22.1278Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9697 12.7476L24.4631 14.263L23.7039 14.5092L23.9697 12.7476Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9697 12.7476L23.4763 14.263L24.2356 14.5092L23.9697 12.7476Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4512 13.8494L24.0475 13.8487L24.0471 14.6446L22.4512 13.8494Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4492 13.849L23.7415 14.7859L24.2115 14.1403L22.4492 13.849Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0312 15.6305L23.525 14.1148L24.2839 14.3608L23.0312 15.6305Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0312 15.6302L24.3232 14.6934L23.8542 14.0491L23.0312 15.6302Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4854 13.8494L23.8891 13.8487L23.8895 14.6446L25.4854 13.8494Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4873 13.849L24.1951 14.7859L23.725 14.1403L25.4873 13.849Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9053 15.6305L24.4116 14.1148L23.6526 14.3608L24.9053 15.6305Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9053 15.6302L23.6133 14.6934L24.0824 14.0491L24.9053 15.6302Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1191 7.35034L18.8272 6.4135L19.2962 5.7692L20.1191 7.35034Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1191 7.35057L19.6254 5.83491L18.8665 6.08088L20.1191 7.35057Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6992 5.56938L19.4077 6.50576L18.9382 5.861L20.6992 5.56938Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6973 5.5696L19.1008 5.56918L19.101 6.36547L20.6973 5.5696Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1787 4.46785L19.6724 5.98351L18.9135 6.22948L19.1787 4.46785Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1787 4.46785L18.6856 5.98306L19.4452 6.22948L19.1787 4.46785Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2422 7.35033L19.5337 6.41396L19.0643 5.76918L18.2422 7.35033Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2422 7.35011L18.7353 5.83488L19.4948 6.08128L18.2422 7.35011Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6611 5.56866L18.953 6.50543L19.4221 5.86104L17.6611 5.56866Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6611 5.56883L19.2576 5.56917L19.2578 6.36554L17.6611 5.56883Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7461 10.8498L22.2398 9.33418L22.9988 9.58015L21.7461 10.8498Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7461 10.8496L23.0381 9.91277L22.569 9.26847L21.7461 10.8496Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.624 10.8496L22.3325 9.91326L22.802 9.26848L23.624 10.8496Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.624 10.8494L23.1309 9.33419L22.3714 9.5806L23.624 10.8494Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2051 9.06801L22.9132 10.0048L22.4441 9.36039L24.2051 9.06801Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2051 9.06818L22.6086 9.06851L22.6084 9.86489L24.2051 9.06818Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.166 9.06871L22.4576 10.0051L22.927 9.36033L21.166 9.06871Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.168 9.06892L22.7644 9.06851L22.7642 9.8648L21.168 9.06892Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6855 7.96724L22.1918 9.4829L22.9508 9.72887L22.6855 7.96724Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6855 7.96724L23.1786 9.48245L22.419 9.72887L22.6855 7.96724Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.168 18.63L22.7641 18.6289L22.7635 19.4246L21.168 18.63Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.167 18.6295L22.4591 19.5661L22.9292 18.9205L21.167 18.6295Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7451 20.4111L22.2396 18.8952L22.9981 19.1407L21.7451 20.4111Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7432 20.4103L23.0355 19.4731L22.5668 18.8292L21.7432 20.4103Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6221 20.4101L22.3307 19.4739L22.8003 18.829L23.6221 20.4101Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6221 20.4094L23.1294 18.8942L22.3697 19.1409L23.6221 20.4094Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6865 17.5276L22.1924 19.0436L22.951 19.2893L22.6865 17.5276Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6865 17.5276L23.1792 19.0426L22.4193 19.2893L22.6865 17.5276Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2031 18.6288L22.6067 18.6293L22.6065 19.4256L24.2031 18.6288Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2031 18.6286L22.9112 19.5655L22.4421 18.9211L24.2031 18.6286Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6621 22.1292L19.2582 22.1281L19.2577 22.9237L17.6621 22.1292Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6611 22.1286L18.9532 23.0653L19.4234 22.4196L17.6611 22.1286Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2402 23.9106L18.7347 22.3947L19.4932 22.6402L18.2402 23.9106Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2383 23.9098L19.5306 22.9726L19.0619 22.3287L18.2383 23.9098Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1162 23.9094L18.8248 22.9732L19.2944 22.3282L20.1162 23.9094Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1162 23.9086L19.6235 22.3935L18.8638 22.6402L20.1162 23.9086Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1826 21.0269L18.6885 22.5428L19.4471 22.7885L19.1826 21.0269Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1826 21.0269L19.6753 22.5418L18.9154 22.7885L19.1826 21.0269Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6982 22.1279L19.1018 22.1283L19.1016 22.9246L20.6982 22.1279Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6982 22.1277L19.4063 23.0645L18.9373 22.4202L20.6982 22.1277Z",
    fill: "#FFCC00"
  })), /*#__PURE__*/React.createElement("rect", {
    x: -7.16699,
    width: 43.11,
    height: 28.6816,
    rx: 5.38875,
    stroke: "#A8B7D4",
    strokeWidth: 0.0265272,
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1928_123554"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.333008,
    width: 28,
    height: 28,
    rx: 14,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1928_123554"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -7.16699,
    width: 43.11,
    height: 28.6816,
    rx: 5.38875,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEur);
export default __webpack_public_path__ + "static/media/EUR.6e67a47cc6fa837b187cf45770b5889c.svg";
export { ForwardRef as ReactComponent };